import { theme } from '../../core/design-system/theme'

/**
 * StepBar — horizontal progress indicator for the 6-step booking flow.
 * @param {object} props
 * @param {number} props.current  1-based current step
 * @param {number} props.total    total steps (default 6)
 */
export function StepBar({ current, total = 6 }) {
  return (
    <div
      role="progressbar"
      aria-valuenow={current}
      aria-valuemin={1}
      aria-valuemax={total}
      aria-label={`Step ${current} of ${total}`}
      style={{
        display: 'flex',
        gap: '6px',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 0 4px',
      }}
    >
      {Array.from({ length: total }, (_, i) => {
        const step = i + 1
        const isCompleted = step < current
        const isCurrent = step === current

        return (
          <div
            key={step}
            style={{
              height: '4px',
              borderRadius: '99px',
              flex: isCurrent ? '2' : '1',
              background: isCompleted || isCurrent
                ? theme.colors.terracotta
                : theme.colors.border,
              opacity: isCompleted ? 0.5 : 1,
              transition: 'all 0.2s ease',
            }}
          />
        )
      })}
    </div>
  )
}
